import { ScrollArea } from '@/components/ui/scroll-area';
import { Newspaper, ExternalLink } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NationalNewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${API}/news/national`);
        setNews(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching national news:', error);
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  return (
    <div className="content-card" data-testid="national-news-section">
      <div className="card-header">
        <h2>
          <Newspaper size={20} className="inline" /> UK National News
        </h2>
      </div>
      <ScrollArea className="card-content">
        {loading ? (
          <p className="loading-text">Loading news...</p>
        ) : (
          <div className="news-list">
            {news.length > 0 ? (
              news.map((item, index) => (
                <div key={item.link || `${item.title}-${index}`} className="news-item" data-testid={`national-news-${index}`}>
                  <h3 className="news-title">{item.title}</h3>
                  {item.summary && <p className="news-summary">{item.summary}</p>}
                  {item.link && (
                    <a 
                      href={item.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="news-link"
                    >
                      Read more <ExternalLink size={14} />
                    </a>
                  )}
                </div>
              ))
            ) : (
              <p className="no-data">No news available</p>
            )}
          </div>
        )}
      </ScrollArea>
    </div>
  );
};

export default NationalNewsSection;